import React from 'react';
import {Link} from "react-router-dom";

interface StartMonitoringProps {
    domain: string | null | undefined;
}

export default function StartMonitoring({domain}: StartMonitoringProps) {
    if (!domain) return (<></>);

    return (
        <div className="row row-50">
            <div className="col-md-12 col-lg-12 col-xl-12">
                <Link 
                    target="_blank" 
                    className="btn btn-primary" 
                    title='Add Domain to Monitoring Service'
                    to={`/monitoring/add-website?website=${domain}`}
                    style={{ marginLeft: "auto", float: 'left' }} 
                >
                Enable Domain Monitoring
                </Link>					
            </div>	
        </div>		
    );
}